// import initialState from '../store/initialState';
import { Types } from '../actions/actionTypes';
import  initialState  from '../store/initialState'


export const inactiveSystemVersionButtonReducer = (state = initialState.inactiveSystemVersionButtonReducer, action) => {
    switch (action.type) {
        case Types.TOGGLE_SYSTEM_INACTIVE_VERSION_BUTTON:
            return { ...state, inactiveSystemVersionButton: action.payload};
        default:
            return state;
    };
};